import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex);
axios.defaults.headers.common = { 'Content-Type': 'application/json' } // INSERITO PERCHè IL SERVER DAVA ERRORI NEI LOG


export default new Vuex.Store({

    state:{
        loading: true,
        step: 1,
        box: ''
    },

    getters:{
        getStep: state => {
            return state.step
        },
    },

    mutations: {
        goToStep(state, step) {
            localStorage.setItem('menaboh_step', step);
            state.step = step;
        },
        POST_BOX: (state, box) => {
            state.box = box;
        },
    },

    actions:{
        SET_STEP: (context, step) => {
            context.commit("POST_STEP", step)
        },
        SET_BOX: (context, box) => {
            context.commit("POST_BOX", box)
        },
    }
  })